/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-01-16 15:16:16
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-05-10 19:06:59
 * @FilePath: \sns-user-frontend\src\jsBridgeApi\index.js
 * @Description: 
 */

import heytapJsApi from "@oppo/lib-heytap-jsapi";

import myOppo from './myOppo'
import oppoApp from './oppoApp'
import oppoStore from './oppoStore'
import oneplusApp from './oneplus'
import onePlusStore from './oneplusStore'
import appMarket from './appMarket'


window.HeytapJsApi = {
  invoke: () => {},
  registeAction: () => {}
};
if (window.HeytapNativeApi && window.HeytapNativeApi.invoke) {
  if (typeof heytapJsApi === "function") {
    window.HeytapJsApi = new heytapJsApi();
  } else {
    window.HeytapJsApi = heytapJsApi;
  }
}

let appName = ''
const isOnePlusCommunity = navigator.userAgent.toLowerCase().includes('oneplus')
const isMyOppoCommunity = navigator.userAgent.toLowerCase().includes('usercenter') && (window.HeytapNativeApi && !!window.HeytapNativeApi.invoke)
const isOppoAppCommunity = navigator.userAgent.includes('OppoCommunity') && (window.HeytapNativeApi && !!window.HeytapNativeApi.invoke)
const isAppMarket = navigator.userAgent.toLowerCase().includes('appmarket') || location.search.includes('fromAppRate')

if (window.OppoStoreClientStoreJS) {
  appName = 'oppoStore'
}
if (window.OnePlusClientBaseJS) {
  appName = 'onePlusStore'
}

if (isMyOppoCommunity) {
  appName = 'myOppo'
}

if (isOppoAppCommunity) {
  appName = 'oppoApp'
}

if (isOnePlusCommunity) {
  appName = 'oneplusApp'
}
if (isAppMarket) {
  appName = 'appMarket'
}

const jsBridge = {
  myOppo,
  oppoApp,
  oppoStore,
  oneplusApp,
  onePlusStore,
  appMarket
}
export default jsBridge[appName]
